import React, {useState} from 'react';
import styles from "./DropdownCity.module.sass";
import {Dropdown} from "react-bootstrap";

export const DropdownCity = () => {
    const [active, setActive] = useState("");

    const handleClick = (event : any) => {
        setActive(event.target.id);
        setTimeout(() => { cityCheck()}, 1);
    }

    const adressCheck1 = () => {
        let adressHeader1 = document.getElementById('adressHeader1') as HTMLDivElement
        let adressHeader2 = document.getElementById('adressHeader2') as HTMLDivElement

        let button1 = document.getElementById('adressButton1') as HTMLButtonElement
        let button2 = document.getElementById('adressButton2') as HTMLButtonElement
        let button3 = document.getElementById('adressButton3') as HTMLButtonElement
        let button4 = document.getElementById('adressButton4') as HTMLButtonElement
        let button5 = document.getElementById('adressButton5') as HTMLButtonElement
        let button6 = document.getElementById('adressButton6') as HTMLButtonElement

        if (window.innerWidth > 851) {
            adressHeader1.innerHTML = 'Казань'
            button1.style.display = 'flex'
            button2.style.display = 'none'
            button3.style.display = 'none'
        }
        if (window.innerWidth < 851) {
            adressHeader2.innerHTML = 'Казань'
            button4.style.display = 'flex'
            button5.style.display = 'none'
            button6.style.display = 'none'
        }
    }

    const adressCheck2 = () => {
        let adressHeader1 = document.getElementById('adressHeader1') as HTMLDivElement
        let adressHeader2 = document.getElementById('adressHeader2') as HTMLDivElement

        let button1 = document.getElementById('adressButton1') as HTMLButtonElement
        let button2 = document.getElementById('adressButton2') as HTMLButtonElement
        let button3 = document.getElementById('adressButton3') as HTMLButtonElement
        let button4 = document.getElementById('adressButton4') as HTMLButtonElement
        let button5 = document.getElementById('adressButton5') as HTMLButtonElement
        let button6 = document.getElementById('adressButton6') as HTMLButtonElement

        if (window.innerWidth > 851) {
            adressHeader1.innerHTML = 'Уфа'
            button1.style.display = 'none'
            button2.style.display = 'flex'
            button3.style.display = 'flex'
        }
        if (window.innerWidth < 851) {
            adressHeader2.innerHTML = 'Уфа'
            button4.style.display = 'none'
            button5.style.display = 'flex'
            button6.style.display = 'flex'
        }
    }

    const cityCheck = () => {

        let cityButton1 = document.getElementById('KazanCityButton2') as HTMLButtonElement;
        let cityClass1 = cityButton1.className
        let cityButton2 = document.getElementById('UfaCityButton2') as HTMLButtonElement;
        let cityClass2 = cityButton2.className

        let cityButton3 = document.getElementById('KazanCityButton') as HTMLButtonElement;
        let cityClass3 = cityButton1.className
        let cityButton4 = document.getElementById('UfaCityButton') as HTMLButtonElement;
        let cityClass4 = cityButton2.className
        if (cityClass1 == 'active') {
            cityButton1.style.border = '1px solid white'
            cityButton1.style.borderRadius = '20px'
            cityButton2.style.border = '1px solid #242526'
            cityButton2.style.borderRadius = '20px'
            if (cityButton3 !== null || cityButton4 !== null) {
                cityButton3.style.border = '1px solid white'
                cityButton3.style.borderRadius = '20px'
                cityButton4.style.border = '1px solid #242526'
                cityButton4.style.borderRadius = '20px'
                let dropdownPhoneButton = document.getElementById('dropdownPhoneButton') as HTMLDivElement;
                dropdownPhoneButton.setAttribute("href", "tel:+79872150506")
            }
            let startPhone = document.getElementById('startPhone') as HTMLDivElement;
            startPhone.innerHTML = '+7 (987) 215-05-06'

            let dropdownCityToggle = document.getElementById('dropdownCityToggle') as HTMLDivElement;
            dropdownCityToggle.innerHTML = 'Казань'

            let orderPhone = document.getElementById('orderPhone') as HTMLDivElement;
            orderPhone.setAttribute("href", "tel:+79872150506")

            let footerPhone = document.getElementById('footerPhone') as HTMLDivElement;
            footerPhone.innerHTML = '+7 (987) 215-05-06'
            footerPhone.setAttribute("href", "tel:+79872150506")

            let orderTg = document.getElementById('orderTg') as HTMLDivElement;
            orderTg.setAttribute("href", "https://t.me/vashe_velichie_kazan")

            let footerTg = document.getElementById('footerTg') as HTMLDivElement;
            footerTg.setAttribute("href", "https://t.me/vashe_velichie_kazan")

            let headerPhoneButton = document.getElementById('headerPhone') as HTMLDivElement;
            headerPhoneButton.innerHTML = '+7 (987) 215-05-06'

            adressCheck1()

        } else if (cityClass2 == 'active') {

            cityButton2.style.border = '1px solid white'
            cityButton2.style.borderRadius = '20px'
            cityButton1.style.border = '1px solid #242526'
            cityButton1.style.borderRadius = '20px'
            if (cityButton3 !== null || cityButton4 !== null) {
                cityButton4.style.border = '1px solid white'
                cityButton4.style.borderRadius = '20px'
                cityButton3.style.border = '1px solid #242526'
                cityButton3.style.borderRadius = '20px'
                let dropdownPhoneButton = document.getElementById('dropdownPhoneButton') as HTMLDivElement;
                dropdownPhoneButton.setAttribute("href", "tel:+73472149410")
            }
            let startPhone = document.getElementById('startPhone') as HTMLDivElement;
            startPhone.innerHTML = '+7 (347) 214-94-10'

            let dropdownCityToggle = document.getElementById('dropdownCityToggle') as HTMLDivElement;
            dropdownCityToggle.innerHTML = 'Уфа'

            let orderPhone = document.getElementById('orderPhone') as HTMLDivElement;
            orderPhone.setAttribute("href", "tel:+73472149410")

            let footerPhone = document.getElementById('footerPhone') as HTMLDivElement;
            footerPhone.innerHTML = '+7 (347) 214-94-10'
            footerPhone.setAttribute("href", "tel:+73472149410")

            let orderTg = document.getElementById('orderTg') as HTMLDivElement;
            orderTg.setAttribute("href", "https://t.me/vashevelichie")


            let footerTg = document.getElementById('footerTg') as HTMLDivElement;
            footerTg.setAttribute("href", "https://t.me/vashevelichie")

            let headerPhoneButton = document.getElementById('headerPhone') as HTMLDivElement;
            headerPhoneButton.innerHTML = '+7 (347) 214-94-10'

            adressCheck2()

        }

    }
    return (
        <div className={styles.dropdown__wrap}>
            <Dropdown>
                <Dropdown.Toggle className={styles.toggleCity} id="dropdown-button-dark-example1" variant="secondary">
                    <button id='dropdown2' className={styles.header__button__phone}>
                        <a id='dropdownCityToggle' className={styles.header__buttonText__phone}>Казань</a>
                    </button>
                </Dropdown.Toggle>
                <Dropdown.Menu className={styles.dropdown__menu} variant="dark">
                    <span className={styles.dropdown__text__default}>Ваш город?</span>
                    <div className={styles.dropdown__city__row}>
                        <button className={active === "KazanCityButton2" ? "active" : undefined}
                                id={"KazanCityButton2"}
                                onClick={handleClick}>
                            Казань
                        </button>
                        <button
                            className={active === "UfaCityButton2" ? "active" : undefined}
                            id={"UfaCityButton2"}
                            onClick={handleClick}>
                            Уфа
                        </button>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};
